// 此文件用于判断当前环境（测试环境/生产环境），并返回对应环境的接口域名
const development = { // 测试环境
  ipServer: 'http://ipinversion.fxeyeinterface.com',
  fxServer: 'http://testwikidatacenter.fxeyeinterface.com:32366',
  fxClient: 'https://testwikidatacenter.fx696.com:32377',
  shieldServer: 'http://shieldcenterapi.fxeyeinterface.com'
}

const production = { // 生产环境
  fxServer: 'http://wikidatacenter.fxeyeinterface.com:32366',
  fxClient: 'https://wikidatacenter.interface003.com:32377'
}

for (const k in development) {
  if (production[k]) continue // 若生产环境存在和测试环境一样的key值，则跳过本次循环
  production[k] = development[k] // 若上述条件不满足，说明生产环境地址和测试环境地址一样，则直接复用测试环境的地址
}

export default (process.env.NODE_ENV != 'production') ? development : production
